import {selectors} from '../../../constants';
import {Component} from './component';

export class SignInControl extends Component {
  get disabled() {
    return this.$input.disabled;
  }
  set disabled(value) {
    this.$input.disabled = value;
  }

  get hidden() {
    return this.$root.hidden;
  }
  set hidden(value) {
    this.$root.hidden = value;
  }

  protected get $helptext() {
    return this.$root.querySelector(selectors.CONTROL_HELPTEXT);
  }

  protected get $input() {
    const $input = this.$root.querySelector(selectors.CONTROL_INPUT);
    if ($input == null) {
      throw new Error(`Input element not found in component "${this.name}"`);
    }
    return $input as HTMLInputElement;
  }

  registerInteractionHandler(type: string, listener: EventListener) {
    this.$input.addEventListener(type, listener);
  }

  deregisterInteractionHandler(type: string, listener: EventListener) {
    this.$input.removeEventListener(type, listener);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/ui/components/sign-in-control.ts